export default __webpack_public_path__ + "content/media/17.b103cfa9.jpg";